import React from 'react';
import { AccordionContext } from './accordion-context';
import { StyledContent, StyledContentWrapper } from './styles';

export const AccordionContent: React.FC<AccordionContentProps> = ({
  children,
}) => {
  const { expanded, id } = React.useContext(AccordionContext);

  return (
    <StyledContentWrapper
      expanded={expanded}
      aria-labelledby={`accordion-header${id}`}
    >
      <StyledContent>{children}</StyledContent>
    </StyledContentWrapper>
  );
};
interface AccordionContentProps {
  children: React.ReactChild | React.ReactFragment | React.ReactPortal;
}
